import { render, staticRenderFns } from "./table-model-button-group.vue?vue&type=template&id=60193083&scoped=true&"
import script from "./table-model-button-group.vue?vue&type=script&lang=js&"
export * from "./table-model-button-group.vue?vue&type=script&lang=js&"
import style0 from "./table-model-button-group.vue?vue&type=style&index=0&id=60193083&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60193083",
  null
  
)

export default component.exports